export enum AlarmCentralJflProblems {
  LOW_BATTERY_WIRELESS_SENSOR = 'LOW_BATTERY_WIRELESS_SENSOR',
  SENSOR_SUPERVISION = 'SENSOR_SUPERVISION',
  AUXILIARY_OUTPUT = 'AUXILIARY_OUTPUT',
  TAMPER = 'TAMPER',
  DHCP = 'DHCP',
  NETWORK_CABLE = 'NETWORK_CABLE',
  CELL_MODULE = 'CELL_MODULE',
  SMS = 'SMS',

  ETHERNET = 'ETHERNET',
  GPRS = 'GPRS',
  PHONE_LINE = 'PHONE_LINE',
  SHORT_CIRCUIT = 'SHORT_CIRCUIT',
  KEYBOARD = 'KEYBOARD',
  SIREN = 'SIREN',
  BATTERY = 'BATTERY',
  AC_POWER = 'AC_POWER',

  INVERTED_BATTERY = 'INVERTED_BATTERY',
  DESTINATION_IP_2 = 'DESTINATION_IP_2',
  DESTINATION_IP_1 = 'DESTINATION_IP_1',
  DNS_SERVER = 'DNS_SERVER',
  AC_KEYBOARD_NETWORK = 'AC_KEYBOARD_NETWORK',
  SIREN_SUPERVISION = 'SIREN_SUPERVISION',
  WIFI_PASSWORD = 'WIFI_PASSWORD',
  WIFI_AUTH = 'WIFI_AUTH',

  SSID_NOT_FOUND = 'SSID_NOT_FOUND',
  IP_CONFLICT = 'IP_CONFLICT',
  BUS = 'BUS',
  DDNS = 'DDNS',
  NOTIFICATION = 'NOTIFICATION',
  ETHERNET_MODULE = 'ETHERNET_MODULE',
  SIGNAL_LEVEL_OR_OPERATOR = 'SIGNAL_LEVEL_OR_OPERATOR',
  SIM_CARD = 'SIM_CARD',

  KEYBOARD_TAMPER = 'KEYBOARD_TAMPER',
  PGM_SUPERVISION = 'PGM_SUPERVISION',
}

export enum ZoneStatusJfl {
  DISABLED = 'DISABLED',
  INHIBITED = 'INHIBITED',
  IN_FIRING = 'IN_FIRING',
  NO_COMMUNICATION = 'NO_COMMUNICATION',
  SHORT = 'SHORT',
  TAMPER_OPEN = 'TAMPER_OPEN',
  LOW_BATTERY = 'LOW_BATTERY',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum PartitionStatusJfl {
  UNSCHEDULED = 'UNSCHEDULED',
  DISARMED_WITHOUT_SHOOTING = 'DISARMED_WITHOUT_SHOOTING',
  ARMED_WITHOUT_SHOOTING = 'ARMED_WITHOUT_SHOOTING',
  ARMED_STAY_WITHOUT_SHOOTING = 'ARMED_STAY_WITHOUT_SHOOTING',
  DISARMED_SHOOTING = 'DISARMED_SHOOTING',
  ARMED_SHOOTING = 'ARMED_SHOOTING',
  ARMED_STAY_SHOOTING = 'ARMED_STAY_SHOOTING',
  DISABLED = 'DISABLED',
}

export enum ElectrifierPartitionStatusJfl {
  NOT_PROGRAMMED = 'NOT_PROGRAMMED',
  DISARMED_WITHOUT_SHOOTING = 'DISARMED_WITHOUT_SHOOTING',
  ARMED_WITHOUT_SHOOTING = 'ARMED_WITHOUT_SHOOTING',
  DISARMED_WITH_SHOOTING = 'DISARMED_WITH_SHOOTING',
  ARMED_WITH_SHOOTING = 'ARMED_WITH_SHOOTING',
  DISABLED = 'DISABLED',
}
